import { useState } from "react";
import CalendarBody from "../../../../../calendar/carouselCalendar/Calendar/CalendarBody";
import { getWeekInterval } from "../../../../../calendar/carouselCalendar/Calendar/CalendarBody/utils";
import CalendarHeader from "../../../../../calendar/carouselCalendar/Calendar/CalendarHeader";
import { Direction } from "../../../../../calendar/carouselCalendar/types";

interface Props {
    moveSlide?: (direction: Direction) => void;
    week?: number;
    setWeeks: React.Dispatch<React.SetStateAction<number[]>>;
}

const Calendar = ({ week, moveSlide, setWeeks }: Props) => {
    const [weekInterval, setWeekInterval] = useState(() => getWeekInterval(0));

    if (!moveSlide || !week) {
        return null;
    }

    return (
        <>
            <CalendarHeader
                week={week}
                moveSlide={moveSlide}
                weekInterval={weekInterval}
                isSettings
                setWeeks={setWeeks}
            />
            <CalendarBody
                week={week}
                setWeekInterval={setWeekInterval}
                isSettings
            />
        </>
    );
};

export default Calendar;
